import React from "react"
import { ReactionsList, ReactionsListProps } from "stream-chat-react"
import { useReactions } from "source/shared/hooks/useReactions"

export const CustomReactionsList = (props: ReactionsListProps) => {
  const reactionOptions = useReactions()

  return <ReactionsList {...props} reactionOptions={reactionOptions} />
}
